import type { JSX as EmotionJSX } from "@emotion/react/jsx-runtime";
import type { SitewideOrdersScope } from "@src/store/types/sitewideDashboardFilters";

export const DashboardPages = [
  "overview",
  "profit",
  "performance",
  "audience",
  "revenue",
  "shipping",
  "visitors",
  "orders",
  "discounts",
  "productGroups",
  "impact",
  "singlePersonalizationTotal",
  "timeSeries",
  "personalizations",
  "statSig",
  "subscriptions",
  "alwaysOnCumulative",
  "dataReconciliation",
  "goals",
  "conversion",
  "customMetrics",
  "orderDistribution",
  "postTestMetrics",
  "checkoutUpsell",
  "onsiteUpsell",
] as const;

export type DashboardPageName = (typeof DashboardPages)[number];

export type DashboardRenderFlags = {
  [key in DashboardPageName]: boolean;
};

export type AnalyticFiltersConfigType = {
  label: string;
  settings: Array<{
    key: string;
    description?: string;
    customDescription?: EmotionJSX.Element;
    component: EmotionJSX.Element;
  }>;
  showOnPage?: DashboardPageName | "all";
  // if filter is a switch (determines the grid direction)
  isSwitch?: boolean;
  dontShowOnPage?: string;
  // config that determines what to show
  config?: boolean;
  // can the user send a default value to BE
  hasDefault?: boolean;
  tooltip?: string;
};

export type SitewideAnalyticFiltersConfigType = AnalyticFiltersConfigType & {
  showOnOrdersScope?: SitewideOrdersScope;
  ordersMatchedToSession?: SitewideOrdersScope;
};

export const SitewideAnalyticsPages = [
  "audience",
  "conversion",
  "home",
  "holidayBenchmark",
  "metaAds",
  "orderDistribution",
  "performance",
] as const;

export type SitewideAnalyticsPageName = (typeof SitewideAnalyticsPages)[number];

export const AnalyticsPageTypes = [
  "sitewide",
  "experiment_analytics",
  "personalization_analytics",
] as const;

export type AnalyticsPageType = (typeof AnalyticsPageTypes)[number];
